import { render, staticRenderFns } from "./BaseTagSelect.vue?vue&type=template&id=3743568d&"
import script from "./BaseTagSelect.vue?vue&type=script&lang=js&"
export * from "./BaseTagSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseTagSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports